import React from 'react';

function NotificationsBubble(props) {
    const { className = '', children } = props;

    if (!children) return null;

    return <div className={['Bubble', className].join(' ')}>{children}</div>;
}

export default NotificationsBubble;
